<template>
  <div ref="generate-course-confirmation-overlay" class="app-modal-dialog--generate-course-confirmation-overlay app-modal-dialog" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="app-modal-dialog__content modal-dialog">
            <div class="app-modal-dialog__header">
                <div class="element-featured-icon is--warning">
                    <svg class="element-icon--warning element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-warning"></use></svg>
                </div>
                <h2 class="app-modal-dialog__title">{{ title }}</h2>
            </div>
            <div class="app-modal-dialog__body">
                <div class="col-12">
                    Once the course has been generated, the outline can no longer be regenerated.
                </div>
            </div>
            <div class="app-modal-dialog__footer"> 
                <app-button
                    theme="secondary"
                    class="element-button--secondary element-button"
                    @click="cancel()">
                    Cancel
                </app-button>
                <app-button
                    theme="primary"
                    class="element-button--primary element-button"
                    :disabled="disabled"
                    @click="confirm()">
                    {{ disabled ? 'Generating...' : 'Confirm' }}
                </app-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    title: {
        type: String,
        default: 'Are you sure?'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    confirm() {
      this.$emit('confirm');
    }
  }
}
</script>
